import * as z from 'zod';
import { SITE_TYPE, COUNTRY_MAP } from 'src/features/sites/utils/types';

export type SiteFormSchemaValues = z.infer<typeof siteFormSchema>;
export const siteFormSchema = z.object({
    coordinates: z.object({
        type: z.string(),
        coordinates: z.array(z.number().min(-90).max(90)),
    }),
    translations: z
        .array(
            z.object({
                language: z.string().nonempty(),
                name: z.string().nonempty(),
                address: z.string().nonempty(),
                city: z.string().nonempty(),
            }),
        )
        .min(1),
    total_spaces: z.number().min(1),
    floors: z.number().min(0),
    country: z.enum(COUNTRY_MAP),
    type: z.enum(SITE_TYPE),
    is_24_7: z.boolean(),
    service_provider: z.string().nonempty(),
});